var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [(_vm.isRender) ? _c('span', [_c('v-icon-button', {
    attrs: {
      "disabled": _vm.current === 1
    },
    on: {
      "click": function($event) {
        _vm.handleClick(_vm.current - 1)
      }
    }
  }, [_vm._v("\n            chevron_left\n        ")]), _vm._v(" "), _vm._l((_vm.middle), function(page, index) {
    return _c('span', {
      key: index
    }, [(page === null) ? _c('span', {
      directives: [{
        name: "margin",
        rawName: "v-margin.left",
        value: (2),
        expression: "2",
        modifiers: {
          "left": true
        }
      }, {
        name: "margin",
        rawName: "v-margin.right",
        value: (2),
        expression: "2",
        modifiers: {
          "right": true
        }
      }]
    }, [_vm._v(". . .")]) : _c('v-button', {
      attrs: {
        "flat": page !== _vm.current,
        "primary": page === _vm.current
      },
      on: {
        "click": function($event) {
          _vm.handleClick(page)
        }
      }
    }, [_vm._v("\n                " + _vm._s(page) + "\n            ")])], 1)
  }), _vm._v(" "), _c('v-icon-button', {
    attrs: {
      "disabled": _vm.current === _vm.pages
    },
    on: {
      "click": function($event) {
        _vm.handleClick(_vm.current + 1)
      }
    }
  }, [_vm._v("\n            chevron_right\n        ")])], 2) : _vm._e()])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-18b452bd","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/baseComponents/components/Pagination/Pagination.vue
// module id = 636
// module chunks = 0